import globalConfig from '../../utiles/globalConfig';
import diffType from './_type';

const page = {
  home: 'home',
  selectProductPage: 'select-product-page',
  pay: 'pay-page',
  vip: 'vip-page',
  event: 'event-page',
  bankInfo: 'bank-detail-page',
  result: `${
    globalConfig.getHrefParam('result') == 1
      ? 'result-succ-page'
      : 'result-fail-page'
  }`,
  browserPay: 'wait-page',
  web: 'web-ready-page'
};

export default {
  event: {
    'j-again-role': [
      {
        type: 'click',
        event: 'click-again-role-btn'
      }
    ],
    'j-select-lang-ele': [
      {
        type: 'change',
        event: 'click-update-lang'
      },
      {
        type: 'focus',
        event: 'click-open-lang-list-btn'
      }
    ],
    'j-click-login-way-account': [
      {
        type: 'click',
        event: 'click-login-way-account'
      }
    ],
    'j-click-login-way-uid': [
      {
        type: 'click',
        event: 'click-login-way-uid'
      }
    ],
    'j-click-logout-account': [
      {
        type: 'click',
        event: 'click-logout-account'
      }
    ],
    'j-click-logout-uid': [
      {
        type: 'click',
        event: 'click-logout-uid'
      }
    ],
    'j-reselect-role': [
      {
        type: 'click',
        event: 'click-reselect-role-btn'
      }
    ],
    'j-click-input-uid': [
      {
        type: 'focus',
        event: 'click-input-uid'
      }
    ],
    'j-click-uid-guide-tip': [
      {
        type: 'click',
        event: 'click-uid-guide-tip'
      }
    ],
    'click-uid-guide-close': [
      {
        type: 'click',
        event: 'click-uid-guide-close'
      }
    ],
    'j-select-server-ele-account': [
      {
        type: 'change',
        event: 'click-update-server-account'
      },
      {
        type: 'focus',
        event: 'click-open-server-list-btn-account'
      }
    ],
    'j-select-role-ele-account': [
      {
        type: 'change',
        event: 'click-update-role-account'
      },
      {
        type: 'focus',
        event: 'click-open-role-list-btn-account'
      }
    ],
    'j-click-search-uid': [
      {
        type: 'click',
        event: 'click-search-uid'
      }
    ],
    'j-select-server-ele-uid': [
      {
        type: 'change',
        event: 'click-update-server-uid'
      },
      {
        type: 'focus',
        event: 'click-open-server-list-btn-uid'
      }
    ],
    'j-select-role-ele-uid': [
      {
        type: 'change',
        event: 'click-update-role-uid'
      },
      {
        type: 'focus',
        event: 'click-open-role-list-btn-uid'
      }
    ],
    'j-select-product': [
      {
        type: 'click',
        event: 'click-update-product'
      }
    ],
    'j-select-product-popup': [
      {
        type: 'click',
        event: 'click-update-product-popup'
      }
    ],
    'j-click-open-product-detail': [
      {
        type: 'click',
        event: 'click-open-product-detail'
      }
    ],
    'j-select-product-type': [
      {
        type: 'click',
        event: 'click-update-product-type'
      }
    ],
    'j-select-order': [
      {
        type: 'click',
        event: 'click-update-order'
      }
    ],
    'j-select-area': [
      {
        type: 'click',
        event: 'click-update-area'
      }
    ],
    'j-select-payType': [
      {
        type: 'click',
        event: 'click-update-channel'
      }
    ],
    'j-area-dcount': [
      {
        type: 'click',
        event: 'click-open-channel-list-btn'
      }
    ],
    'j-click-more-channel': [
      {
        type: 'click',
        event: 'click-more-channel'
      }
    ],
    'j-go-feeback-btn': [
      {
        type: 'click',
        event: 'click-go-feeback-btn'
      }
    ],
    'j-restore-btn': [
      {
        type: 'click',
        event: 'click-go-restore-btn',
        newPage: true
      }
    ],
    'j-goback-game-btn': [
      {
        type: 'click',
        event: 'click-goback-game-btn'
      }
    ],
    submitLoading: [
      {
        type: 'click',
        event: 'click-submit-btn',
        newPage: true,
        pageName: page.pay
      }
    ],
    'j-submit-nbtn': [
      {
        type: 'click',
        event: 'click-submit-btn',
        newPage: true
      }
    ],
    'j-service-float-btn': [
      {
        type: 'click',
        event: 'click-service-float-btn',
        newPage: true
      }
    ],
    'j-change-product': [
      {
        type: 'click',
        event: 'click-change-product'
      }
    ],
    productList: [
      {
        type: 'click',
        event: 'show-product-list',
        pageName: page.selectProductPage
      }
    ],
    'j-click-add-to-cart-product-list': [
      {
        type: 'click',
        event: 'click-add-to-cart-product-list'
      }
    ],
    'j-click-add-to-cart-detail-popup': [
      {
        type: 'click',
        event: 'click-add-to-cart-detail-popup'
      }
    ],
    'j-click-confirm-cart': [
      {
        type: 'click',
        event: 'click-confirm-cart'
      }
    ],
    'j-click-open-cart': [
      {
        type: 'click',
        event: 'click-open-cart'
      }
    ],
    'j-click-close-cart': [
      {
        type: 'click',
        event: 'click-close-cart'
      }
    ],
    'j-click-add-to-cart-cart-list': [
      {
        type: 'click',
        event: 'click-add-to-cart-cart-list'
      }
    ],
    'j-click-sub-to-cart-cart-list': [
      {
        type: 'click',
        event: 'click-sub-to-cart-cart-list'
      }
    ],
    'j-click-delete-to-cart-popup': [
      {
        type: 'click',
        event: 'click-delete-to-cart-popup'
      }
    ],
    'j-click-cancel-delete-to-cart-popup': [
      {
        type: 'click',
        event: 'click-cancel-delete-to-cart-popup'
      }
    ],
    'j-click-look-all-cart': [
      {
        type: 'click',
        event: 'click-look-all-cart'
      }
    ],
    'j-click-close-cart-detail-popup': [
      {
        type: 'click',
        event: 'click-close-cart-detail-popup'
      }
    ],
    'j-click-select-pay-way-cart': [
      {
        type: 'click',
        event: 'click-select-pay-way-cart'
      }
    ],
    'j-select-coupon-entry': [
      {
        type: 'click',
        event: 'click-select-coupon-entry',
        pageName: page.pay
      }
    ],
    'j-select-coupon-item': [
      {
        type: 'click',
        event: 'click-select-coupon-item',
        pageName: page.pay
      }
    ],
    'j-click-coupon-use': [
      {
        type: 'click',
        event: 'click-coupon-use',
        pageName: page.pay
      }
    ],
    'j-click-coupon-close': [
      {
        type: 'click',
        event: 'click-coupon-popup-close',
        pageName: page.pay
      }
    ],
    'j-click-coupon-confirm-sure': [
      {
        type: 'click',
        event: 'click-coupon-confirm-sure',
        pageName: page.pay
      }
    ],
    'j-click-coupon-confirm-cancel': [
      {
        type: 'click',
        event: 'click-coupon-confirm-cancel',
        pageName: page.pay
      }
    ],
    'j-click-top-my-coupon': [
      {
        type: 'click',
        event: 'click-top-my-coupon',
        pageName: page.pay
      }
    ],
    'j-click-top-vip-score': [
      {
        type: 'click',
        event: 'click-top-vip-score',
        pageName: page.pay
      }
    ],
    'j-click-coupon-item-use': [
      {
        type: 'click',
        event: 'click-coupon-item-use',
        pageName: page.pay
      }
    ],
    'j-click-vip-go-benefit-center': [
      {
        type: 'click',
        event: 'click-vip-go-benefit-center',
        pageName: page.vip
      }
    ],
    'j-click-vip-my-coupon': [
      {
        type: 'click',
        event: 'click-vip-my-coupon',
        pageName: page.vip
      }
    ],
    'j-click-vip-ratio': [
      {
        type: 'click',
        event: 'click-vip-ratio',
        pageName: page.vip
      }
    ],
    'j-click-vip-coupon-limit-ratio': [
      {
        type: 'click',
        event: 'click-vip-coupon-limit-ratio',
        pageName: page.vip
      }
    ],
    'j-click-vip-back': [
      {
        type: 'click',
        event: 'click-vip-back',
        pageName: page.vip
      }
    ],
    'j-click-award-bag': [
      {
        type: 'click',
        event: 'click-award-bag',
        pageName: page.event
      }
    ],
    'j-click-event-rule': [
      {
        type: 'click',
        event: 'click-event-rule',
        pageName: page.event
      }
    ],
    'j-click-event-tab1': [
      {
        type: 'click',
        event: 'click-event-tab1',
        pageName: page.event
      }
    ],
    'j-click-event-tab2': [
      {
        type: 'click',
        event: 'click-event-tab2',
        pageName: page.event
      }
    ],
    'j-click-event-copy': [
      {
        type: 'click',
        event: 'click-event-copy',
        pageName: page.event
      }
    ],
    'j-click-twitter-share': [
      {
        type: 'click',
        event: 'click-twitter-share',
        pageName: page.event
      }
    ],
    'j-click-facebook-share': [
      {
        type: 'click',
        event: 'click-facebook-share',
        pageName: page.event
      }
    ],
    'j-click-discord-share': [
      {
        type: 'click',
        event: 'click-discord-share',
        pageName: page.event
      }
    ],
    'j-click-event-refresh': [
      {
        type: 'click',
        event: 'click-event-refresh',
        pageName: page.event
      }
    ],
    'j-click-event-bind': [
      {
        type: 'click',
        event: 'click-event-bind',
        pageName: page.event
      }
    ],
    'j-click-event-back': [
      {
        type: 'click',
        event: 'click-event-back',
        pageName: page.event
      }
    ],
    'j-credit-card-item': [
      {
        type: 'click',
        event: 'click-credit-card-choose',
        pageName: page.event
      }
    ],
    'j-click-use-cart-guide': [
      {
        type: 'click',
        event: 'click-use-cart-guide',
        pageName: page.pay
      }
    ]
  },
  enter: {
    payPage: { event: page.pay }
  },
  observer: {
    submitLoading: {
      pre: false,
      now: true,
      action: 'event',
      type: 'data',
      page: 'payPage',
      diffType: diffType.equal
    },
    productList: {
      action: 'event',
      type: 'computed',
      page: 'webSelectProduct',
      diffType: diffType.noEmptyArrayPre
    }
  },
  router: {
    home: { event: page.home },
    bankInfo: { event: page.bankInfo },
    result: {
      event: page.result
    },
    pay: { event: page.pay }
  }
};
